import { MenuItem, Select } from "@mui/material";

import { useMapState } from "contexts/MapStateContext";

export default function SuitabilityControl(params) {
  const { suitabilityLayer, setSuitabilityLayer } = useMapState();
  return (
    <Select
      variant="standard"
      labelId="suitability-label"
      id="select-suitability"
      value={suitabilityLayer}
      onChange={(event) => setSuitabilityLayer(event.target.value)}
      fullWidth
      sx={{ my: 1 }}
    >
      <MenuItem value="none">Suitability Hidden</MenuItem>
      <MenuItem value="benefit_to_cost_ratio_community">
        Cost-Benefit Ratio
      </MenuItem>
      <MenuItem value="total_benefit_community">Benefits</MenuItem>
      <MenuItem value="delta_benefit">Mitigation Benefit</MenuItem>
      <MenuItem value="building_benefit">Community Benefit</MenuItem>
      <MenuItem value="density_benefit">Network Benefit</MenuItem>
      <MenuItem value="pre_ros_benefit">ROS Benefit</MenuItem>
      <MenuItem value="total_cost">Total Cost</MenuItem>
      <MenuItem value="slope_cost">Slope Cost</MenuItem>
      <MenuItem value="road_cost">Road Cost</MenuItem>
      <MenuItem value="slope_accessibility">Slope Accessibility</MenuItem>
    </Select>
  );
}
